import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { ExtendedUnitFilterOptions, RootStateTypeExtra } from '../types'

const unitFilter = localStorage.getItem('unitFilter')

export const initialFilter = {
  range: {
    min: 'Any',
    max: 'Any',
  },
  aspect: [],
  unitType: 'Any',
  configurations: {
    bed: {
      min: 'Any',
      max: 'Any',
    },
    study: {
      min: 'Any',
      max: 'Any',
    },
    bath: {
      min: 'Any',
      max: 'Any',
    },
    powderRoom: {
      min: 'Any',
      max: 'Any',
    },
    car: {
      min: 'Any',
      max: 'Any',
    },
  },
  showAvailable: false,
  anyLevel: true,
  apply: false,
} as ExtendedUnitFilterOptions

let initialState = { ...initialFilter }

const prepareData = (
  unitFilterData: ExtendedUnitFilterOptions
): ExtendedUnitFilterOptions => {
  let isValidData = true
  Object.entries(unitFilterData.configurations)?.forEach(([, value]) => {
    if (typeof value !== 'object') {
      isValidData = false
    }
  })
  return isValidData ? unitFilterData : initialState
}

if (unitFilter) {
  initialState = prepareData(JSON.parse(unitFilter))
}

export const unitFilterSlice = createSlice({
  name: 'unitFilter',
  initialState,
  reducers: {
    setFilter: (
      state: ExtendedUnitFilterOptions,
      action: PayloadAction<ExtendedUnitFilterOptions>
    ) => {
      localStorage.setItem(
        'unitFilter',
        JSON.stringify({ ...state, ...action.payload })
      )
      return {
        ...state,
        ...action.payload,
      }
    },
    resetFilter: () => {
      localStorage.setItem('unitFilter', JSON.stringify(initialFilter))
      return initialFilter
    },
    removeFilter: () => {
      localStorage.removeItem('unitFilter')
      return initialFilter
    },
  },
})

export const { setFilter, resetFilter, removeFilter } = unitFilterSlice.actions

export const selectFilteredUnit = (state: RootStateTypeExtra) =>
  state.unitFilter

export default unitFilterSlice.reducer
